import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import ProductCategory1 from '../brown-paper-bags/Product-category-section/product-category1';
import ProductCategory2 from '../brown-paper-bags/Product-category-section/product-category2';
// import ProductCategory3 from '../brown-paper-bags/Product-category-section/product-category3';
// import ProductCategory4 from '../brown-paper-bags/Product-category-section/product-category4';
// import ProductCategory5 from '../brown-paper-bags/Product-category-section/product-category5';
// import ProductCategory6 from '../brown-paper-bags/Product-category-section/product-category6';
const BrownPaperBags = () => {
  const navigate=useNavigate()
  return (
    <>
    <div className="container-fluid  bags-container d-flex align-items-center" >
      <div className="row justify-content-center w-100">
        <div className="col-12 col-lg-10">
          <div className="card-banner">
            <div className="row g-0">
              {/* Left side with single product image */}
              <div className="col-md-6  d-flex align-items-center justify-content-center p-5" >
                <img
                  src="/assets/products-with-logo/paper-bags/brown-paper-bags-large-size.png"
                  className="img-fluid"
                  alt="Bag Product"
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>
              
              {/* Right side content */}
              <div className="col-md-6 d-flex align-items-center" >
                <div className="p-4 p-lg-5 w-100">
                  <small className="text-black text-uppercase letter-spacing-1 mb-2 d-block">
                  Natural, sustainable, reliable
                  </small>
                  
                  <h2 className="main-heading display-5 fw-bold text-dark mb-4">
                  Brown Paper Bags
                  </h2>
                  
                  <p className="product-each-desc text-black mb-4 lead">
                  {/* Brown paper bags are lightweight, and durable, offering a natural, versatile, and eco-friendly packaging solution for diverse applications. */}

                  Brown paper bags provide a convenient and eco-friendly packaging solution for your business. Our twisted handle bags, crafted from virgin kraft paper and recycled kraft paper, are both durable and stylish, making them perfect for various applications. These high-quality bags can reliably support up to 5 kg of distributed weight, providing sufficient strength for heavy items in retail stores, boutiques, and events. We use only water-based inks and premium adhesives to ensure the bags remain odor-free and safe for all packing applications. Through our in-house design team, we can customize the bags to meet your specific size and design requirements. For convenience during trials, unexpected demand surges, or general market needs, we maintain a ready stock of unprinted bags in standard sizes.
                  </p>                  
                  <div className="text-center mb-4">
                    <button 
                      className="btn btn-dark btn-sm rounded-pill text-uppercase mx-auto" 
                      style={{ 
                        width: '100px',
                        fontSize: '0.6rem',
                        padding: '10px 2px',
                        lineHeight: '1.2',
                        display: 'block'
                      }} onClick={()=>{navigate('/contact')}}>
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ProductCategory1/>
        {/* <ProductCategory6/> */}

    <ProductCategory2/>
 
    {/* <ProductCategory3/>
     <ProductCategory4/>
    <ProductCategory5/> */}
</>
  );
};

export default BrownPaperBags;